/**
 * @module app.shared
 */

import { inject, transient } from 'aurelia-framework';
import { noop } from 'app/shared/lib/noop';

@transient()
@inject(Element)
export class MaterializeComponentRefresher<T extends M.Component<any>> {

    public refresh: () => void = noop;
    public get component(): T | null {
        return this.instance;
    }

    protected instance: T | null = null;
    protected observer: MutationObserver | null = null;
    protected options: MutationObserverInit = { childList: true };

    constructor(protected readonly element: Element) { }

    public configure(options: MutationObserverInit) {
        this.options = options;
    }

    public initialize(init: () => T | null, terminate: (() => void) | null = null, disabled: boolean = false) {
        this.refresh = () => {
            if(terminate) {
                terminate();
            }
            if(this.instance) {
                this.instance.destroy();
            }
            this.instance = init();
        }
        if(!disabled) {
            this.refresh();
            this.enable();
        }
    }

    public disable() {
        if(this.observer) {
            this.observer.disconnect();
            this.observer = null;
        }
        if(this.instance) {
            this.instance.destroy();
            this.instance = null;
        }
    }

    public enable() {
        if(!this.instance) {
            return;
        }
        if(!this.observer) {
            this.observer = new MutationObserver(this.refresh);
        }
        this.observer.observe(this.element, this.options);
    }

    public destroy() {
        this.disable();
    }
}
